import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import { Link } from 'react-router-dom';
import apiClient, { WrappingApiClient } from 'libs/api/apiClient';
import { CWindowWidth } from 'constants/base.const';
import { ERoute } from 'enums/route.enum';
import { Typography, Col, Row, List } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { SecondaryColor, device } from 'GlobalStyles';
import quoteImage from 'assets/icons/quote.webp';
import HeaderImg from 'assets/images/banners/4.webp';
import ticket from 'assets/images/banners/ticket.webp';
import LeftImg from 'assets/images/pages/introduce/leftImg.webp';
import RightImg from 'assets/images/pages/introduce/rightImg.webp';

interface IFullScreen {
  isFS: string;
}

const MembershipIntroduction = () => {
  const { Text, Title } = Typography;

  const getPageViews = () => {
    return WrappingApiClient(apiClient.get(`/drill/framework?board=pass_introduce`));
  };

  getPageViews();

  return (
    <>
      <HeaderWrapper>
        <div className='title_wrapper'>
          <Title>Career Step 패스 소개</Title>
          <Text style={{ marginTop: '10px' }}>패스를 구매하시고 케이스 문제를 무제한으로 이용하세요</Text>
        </div>
      </HeaderWrapper>

      <GuideWrapper>
        <Title>
          <span style={{ color: '#3CAC40' }}>Career Step 패스</span>란
        </Title>
        <CSAboutWrapper>
          <Row justify='space-between' align='middle'>
            <Col
              xs={{ span: 24, order: 1 }}
              sm={{ span: 24, order: 1 }}
              md={{ span: 11, order: 2 }}
              lg={{ span: 11, order: 2 }}
              xl={{ span: 11, order: 2 }}
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <CSAboutText className='step-info firstText'>
                <Title>CS 케이스 스터디의 특징</Title>
                <List split={false}>
                  <List.Item.Meta
                    avatar={<CheckOutlined />}
                    description='케이스 인터뷰 준비와 전략적 사고 연습에 특화된 최신 비즈니스 문제'
                  />
                  <List.Item.Meta
                    avatar={<CheckOutlined />}
                    description='주제별, 난이도별, 상황별로 다양하게 연습이 가능한 폭넓은 문제 구성'
                  />
                  <List.Item.Meta
                    avatar={<CheckOutlined />}
                    description='풀기만 해도 케이스 실력이 느는 100개 이상의 양질의 문제'
                  />
                </List>
              </CSAboutText>

              <ScrollAnimation
                className='firstImg'
                animateIn='fadeInLeft'
                animateOnce={true}
                duration={1.5}
                style={{ width: '100%' }}
              >
                <CSAboutImg
                  isFS='true'
                  alt=''
                  src={RightImg}
                  style={{
                    height: 'auto',
                    width: '100%',
                    marginTop: '40px',
                  }}
                />
                <CSAboutImg
                  isFS='false'
                  alt=''
                  src={LeftImg}
                  style={{
                    height: 'auto',
                    width: '100%',
                  }}
                />
              </ScrollAnimation>
            </Col>

            <Col
              xs={{ span: 24, order: 1 }}
              sm={{ span: 24, order: 1 }}
              md={{ span: 11, order: 2 }}
              lg={{ span: 11, order: 2 }}
              xl={{ span: 11, order: 2 }}
            >
              <ScrollAnimation animateIn='fadeInRight' animateOnce={true} duration={1.5}>
                <CSAboutImg
                  isFS='true'
                  alt=''
                  src={LeftImg}
                  style={{
                    height: 'auto',
                    width: '100%',
                    marginBottom: '40px',
                  }}
                />
                <CSAboutImg
                  isFS='false'
                  alt=''
                  src={RightImg}
                  style={{
                    height: 'auto',
                    width: '100%',
                  }}
                />
              </ScrollAnimation>
              <CSAboutText className='step-info step-right'>
                <Title>패스 구매 시 혜택</Title>
                <List split={false}>
                  <List.Item.Meta
                    avatar={<CheckOutlined />}
                    description='모든 문제에 대해 ‘나의 답안’ 채점으로 실시간 피드백'
                  />
                  <List.Item.Meta
                    avatar={<CheckOutlined />}
                    description='MBB 출신 멘토가 직접 작성한 해설 제공'
                  />
                  <List.Item.Meta
                    avatar={<CheckOutlined />}
                    description={
                      <>
                        <span className='originPrice'>정가 150,000원</span> 출시 기념 할인가 100,000원 1회
                        결제 후 3개월 동안
                        <br />
                        무제한 이용 가능
                      </>
                    }
                  />
                </List>
              </CSAboutText>
            </Col>
          </Row>
        </CSAboutWrapper>
      </GuideWrapper>
      <GuideWrapper>
        <Title>사용자 후기</Title>
        <ReviewWrapper>
          <Row gutter={[16, 16]} style={{ margin: '20px auto', padding: '0px' }}>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <img alt='' src={quoteImage} />
              <p className='item'>
                컨설팅 학회 출신이 아니라 부족한 양질의 자료에 대한 아쉬움이 많았는데 케이스 패스로 아쉬움을
                달랠 수 있었습니다
              </p>
              <p className='footer'>21 Fall Bain Asso 합격</p>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <img alt='' src={quoteImage} />
              <p className='item'>
                케이스를 혼자 연습하다보니 맞게 푼건지 항상 궁금했는데, 바로 채점이 되고 자세한 해설이 있어서
                방향성을 잡을 수 있었습니다
              </p>
              <p className='footer'>21 Fall BCG Asso 합격</p>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <img alt='' src={quoteImage} />
              <p className='item'>
                베타 테스트 때부터 이용해봤는데, Structuring 연습에 도움이 되었습니다. 평소에 약하다고 생각한
                부분을 집중 연습할 수 있어서 온라인 테스트와 실제 인터뷰에서는 오히려 Structuring이 가장
                편해졌습니다
              </p>
              <p className='footer'>21 Fall BCG Asso 합격</p>
            </Col>
          </Row>
        </ReviewWrapper>
      </GuideWrapper>
      <BottomWrapper>
        <div className='inner-box'>
          <Title className='title' style={{ marginBottom: '5px' }}>
            Career Step 패스 구매하기
          </Title>
          <Text>지금 구매하시면 100,000원 1회 결제 후 3개월 동안 무제한 이용 가능합니다</Text>
          <div className='purchasePassBtn' style={{ marginTop: '8px' }}>
            <Link to={ERoute.CSLearningPurchasePage}>
              <div
                style={{
                  display: 'inline-block',
                  marginTop: '8px',
                  padding: '14px 12px',
                  backgroundColor: '#ffffff',
                  borderRadius: '8px',
                }}
              >
                패스 구매하기
              </div>
            </Link>
          </div>
        </div>
        <BottomTicketImg alt='' src={ticket} />
      </BottomWrapper>
    </>
  );
};

export default React.memo(MembershipIntroduction);

const maxWidth = CWindowWidth - 200;
const HeaderWrapper = styled.div`
  display: flex;
  justify-content: center;

  .title_wrapper {
    width: 100%;
    height: 400px;
    padding: 100px 10px;
    background: url(${HeaderImg});
    background-size: cover;

    @media screen and ${device.md} {
      height: 205px;
      padding: 80px 10px;
    }

    h1.ant-typography {
      max-width: ${CWindowWidth - 300}px;
      width: 95%;
      margin: 0 auto;
      font-size: 56px;
      color: #ffffff;

      @media screen and ${device.md} {
        font-size: 28px;
      }
    }

    span.ant-typography {
      display: block;
      max-width: ${CWindowWidth - 300}px;
      width: 95%;
      margin: 0 auto;
      font-size: 18px;
      color: #ffffff;

      @media screen and ${device.md} {
        font-size: 14px;
      }
    }
  }
`;

const GuideWrapper = styled.div`
  max-width: ${maxWidth}px;
  width: 70%;
  margin: 120px auto;
  color: #14112a;

  @media screen and ${device.md} {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90%;
    margin: 20px auto 15px auto;
  }

  > h1.ant-typography {
    margin-bottom: 30px;
    font-size: 40px;
    font-weight: 700;

    @media screen and ${device.md} {
      margin: 30px 0 10px 0;
      font-size: 20px;
    }
  }
`;

const BottomWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 248px;
  background-color: #2a4753;

  @media screen and ${device.lg} {
    flex-direction: column;
    height: 385px;
  }

  .inner-box {
    display: block;
    max-width: ${maxWidth}px;
    margin-right: 200px;

    @media screen and ${device.lg} {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 65px auto 0 auto;
      padding: 0 20px;
      order: 2;
    }

    .ant-typography {
      color: #ffffff;
    }

    .ant-typography.title {
      @media screen and ${device.lg} {
        font-size: 24px;
      }
    }

    span.ant-typography {
      margin-top: 8px;
      font-size: 18px;
      color: #83979f;

      @media screen and ${device.lg} {
        font-size: 14px;
      }
    }

    .purchasePassBtn {
      @media screen and ${device.lg} {
        align-self: flex-end;
      }
    }
  }
`;

const CSAboutWrapper = styled.div`
  .ant-list-item-meta-description {
    color: #14112a;
  }

  .firstImg {
    @media screen and ${device.md} {
      order: 1;
    }
  }

  .firstText {
    @media screen and ${device.md} {
      order: 2;
    }
  }
`;

const ReviewWrapper = styled.div`
  .item {
    margin-top: 21px;
    font-size: 18px;
    font-weight: 700;
    color: #14112a;
  }

  .footer {
    float: left;
    height: 32px;
    margin-right: 10px;
    font-size: 14px;
    font-weight: bold;
    color: ${SecondaryColor};
  }
`;

const CSAboutImg = styled.img<IFullScreen>`
  display: ${({ isFS }) => (isFS === 'true' ? 'block' : 'none')};

  @media screen and ${device.md} {
    display: ${({ isFS }) => (isFS === 'false' ? 'block' : 'none')};
    margin: 20px 0;
  }
`;

const CSAboutText = styled.div`
  h1.ant-typography {
    font-size: 28px;
    font-weight: 600;

    @media screen and ${device.md} {
      font-size: 18px;
    }
  }

  .originPrice {
    color: #747474;
    text-decoration: line-through;
  }
`;

const BottomTicketImg = styled.img`
  width: 230px;
  height: 115px;

  @media screen and ${device.lg} {
    order: 1;
  }
`;
